import type { Workspace } from '../types/database';

export const normalizeBrandDomain = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/\/+$/, '')
    .split('/')[0];

export const extractBrandName = (value: string): string => {
  const normalized = normalizeBrandDomain(value);
  const base = normalized.split('.')[0] || normalized;
  return base ? base.charAt(0).toUpperCase() + base.slice(1) : '';
};

export const getWorkspaceBrandName = (
  workspace: Pick<Workspace, 'brand_name' | 'brand_url'> | null | undefined,
  fallback = 'Your brand',
): string => {
  const explicitName = workspace?.brand_name?.trim();
  if (explicitName) return explicitName;
  if (workspace?.brand_url) return extractBrandName(workspace.brand_url);
  return fallback;
};
